import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-finvero-viewer',
  templateUrl: './finvero-viewer.component.html',
  styleUrls: ['./finvero-viewer.component.scss']
})
export class FinveroViewerComponent implements OnInit {
  urlFinvero: SafeResourceUrl | null = null;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const rawUrl = params['url'];
      if (rawUrl) {
        const decodedUrl = decodeURIComponent(rawUrl);
        this.urlFinvero = this.sanitizer.bypassSecurityTrustResourceUrl(decodedUrl);
      }
    });
  }
}
